// @flow
import * as React from 'react';
import OverlayDialog from './OverlayDialog';

type Props = {
    message: string | React.Node,
    actions: {
        [string]: {
            id: string | number,
            text: string | React.Node,
            onClick: (e: SyntheticMouseEvent<HTMLButtonElement>) => void,
            buttonStyle: Object,
            titleStyle: Object,
            [string]: any,
        }
    },
}

const MessageDialog = (props: Props) => {
    const {
        message, actions,
    } = props;

    const [overlayVisible, setOverlayVisible] = React.useState(true);

    const toggleOverlay = () => {
        setOverlayVisible(!overlayVisible);
    };

    return (
        <OverlayDialog
            visible={overlayVisible}
            onBackdrop={toggleOverlay}
            text={message}
            buttons={actions}
        />
    );
};

export default MessageDialog;
